import { Dispatch, SetStateAction, useMemo } from 'react';
import Select from 'react-select';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { extraSelectStyles } from './constants';
import { Nullable, WidgetType } from './types';

export type WidgetTypeOption = { value: WidgetType, label: string };

type WidgetTypeSelectProps = {
  value: Nullable<WidgetTypeOption>
  setter: Dispatch<SetStateAction<Nullable<WidgetTypeOption>>>,
  className?: string,
};

function WidgetTypeSelect({ value, setter, className }: WidgetTypeSelectProps) {
  const { t } = useOTSTranslation('common');

  const widgetTypeOptions: ReadonlyArray<WidgetTypeOption> = useMemo(() => [
    { value: WidgetType.SINGLE_RESORT, label: t('widget.singleResort') },
    { value: WidgetType.LIST_OF_RESORTS, label: t('widget.listOfResorts') },
    { value: WidgetType.SINGLE_REGION, label: t('widget.singleRegion') },
  ], []);

  return (
    <section className={className}>
      <h2>{t('widget.snowWidget')}</h2>
      <h6>{t('widget.chooseWidgetType')}</h6>
      <Select
        id="type.select"
        placeholder={t('widget.pleaseSelect')}
        onChange={setter}
        value={value}
        isSearchable={false}
        options={widgetTypeOptions}
        styles={{ control: (base) => ({ ...base, ...extraSelectStyles }) }}
      />
    </section>
  );
}

export default WidgetTypeSelect;
